//@ts-check
import { combineReducers } from '@reduxjs/toolkit';

import REDUX_SLICE_NAMES from 'src/const/redux-slice-names';

import loadingSliceReducer from './loading/loadingSlice';

const rootReducer = combineReducers({
  [REDUX_SLICE_NAMES.LOADING]: loadingSliceReducer,
});

export default rootReducer;
